export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Vstupenky boli resetované...',
        networkError: 'Chyba komunikácie so serverom, skontrolujte pripojenie k internetu...',
        networkNotAvailable: 'Nepripojené'
    },
    menu: {
        test: 'Test čítačky kódov',
        settings: 'Nastavenia',
        admin: 'Administrácia',
        resetTickets: 'Reset vstupeniek',
        resetState: 'Reset stavu aplikácie',
        logout: 'Odhlásiť'
    },
    home: {
        login: 'Prihlásiť sa',
        lastEvent: 'Skontrolovať poslednú načítanú udalosť / zónu',
        lastEvents: 'Skontrolovať posledné<br />načítané udalosti',
        lastZones: 'Skontrolovať posledné<br />načítané zóny',
        chooseEvent: 'Vyberte udalosť',
        checkEvents: 'Skontrolovať<br />udalosti',
        checkZones: 'Skontrolovať<br />zóny',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Vyberte udalosť',
        chooseEventPast: 'Prebehnuté udalosti',
        confirm: 'Potvrdiť výber udalostí',
        showPast: 'zobraziť prebehnuté'
    },
    zone: {
        chooseZone: 'Vyberte zónu / zóny',
        confirm: 'Potvrdiť výber zón'
    },
    ticketsets: {
        chooseTicketsets: 'Vyberte sadu vstupeniek',
        selectAll: 'Vybrať všetky',
        ticketCount: 'Počet vstupeniek:'
    },
    scanner: {
        tickets: 'Vstupeniek:',
        startReader: 'Spustiť čítačku',
        startReaderDescription:
            'Prehliadač potrebuje interakciu používateľa pre prehrávanie systémových zvukov. Potvrďte tlačidlom "OK".',
        specialWarning: 'Upozornenie',
        specialType: 'Vstupenka špeciálneho typu:',
        refuse: 'Odmietnuť',
        confirm: 'Potvrdiť',
        messageSuccess: 'Kód {code} úspešne uplatnený',
        messageSuccessPrice: 'Kód {code} úspešne uplatnený<br /><big>Cena: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Kód {code} úspešne uplatnený<br /><big>Sada: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Kód {code} úspešne uplatnený<br /><big>Sada vst.: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Kód {code} úspešne uplatnený<br /><big>Udalosť: <b>{event}</b>, sada: {ticketset}</big>',
        messageSuccessNosend: 'Kód {code} úspešne uplatnený (neodoslané)',
        messageRead: 'Bol načítaný kód {code}',
        messageUsed: 'Kód {code} bol už použitý',
        messageNotUsable: 'Kód {code} nie je možné použiť',
        messageUnsend: 'Kód {code} bol už použitý (mnou, neodoslaný)',
        messageNotFound: 'Kód <b>{code}</b> nenájdený v načítaných vstupenkách',
        messageBadSlot: 'Kód {code} nie je platný pre túto zónu/slot',
        messageExtra1: 'použitý na zariadení: <b>{device}</b>, dátum: <b>{date}</b>',
        manualTitle: 'Ručné zadanie kódu',
        loading: 'načítavanie vstupeniek...',
        nfcNotFound: 'Žiadna zo vstupeniek na karte nie je platná'
    },
    login: {
        title: 'Prihlásenie do aplikácie',
        username: 'Prihlasovacie meno',
        password: 'Heslo',
        login: 'Prihlásiť'
    },
    settings: {
        title: 'Nastavenia',
        sound: 'Zvuk',
        soundSub: 'Zapnutie zvukových upozornení',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'Čítať NFC tagy',
        language: 'Jazyk',
        langCs: 'Česky',
        langEn: 'Anglicky',
        langDe: 'Nemecky',
        langHr: 'Chorvátsky',
        langHu: 'Maďarsky',
        langPl: 'Poľsky',
        langSk: 'Slovensky',
        qTitle: 'Detailné nastavenia čítačky',
        qPatchSize: 'Veľkosť dekódovacieho okna',
        qFrequency: 'Frekvencia dekódovania',
        groupDisplay: 'Zobrazenie skupiny / kategórie pri kontrole',
        groupDisplayNone: 'Nezobrazovať nič',
        groupDisplayTicketset: 'Zobraziť sady vstupeniek',
        groupDisplayTicketsetPrice: 'Zobraziť sady vstupeniek a cenovú hladinu',
        groupDisplayPrice: 'Zobraziť cenovú hladinu',
        groupDisplayEvent: 'Zobraziť meno udalosti a sadu',
        olderEvents: 'Ako dlho zobrazovať udalosti po ich ukončení',
        olderEventsWeek: 'Týždeň',
        olderEventsMonth: 'Mesiac',
        olderEvents3Month: '3 mesiace',
        olderEvents6Month: '6 mesiacov',
        olderEventsYear: '1 rok',
        olderEventsAll: 'Zobraziť všetky',
        olderEventsAllList: 'všetky',
        showTicketCount: 'Zobraziť počet vstupeniek',
        showStatistics: 'Zobraziť štatistiky',
        queueTitle: 'Zoznam kódov vo fronte na odoslanie',
        queueSending: 'prebieha odosielanie',
        queueYes: 'ÁNO',
        queueNo: 'NIE',
        queueEmpty: 'Fronta je prázdna'
    },
    statistics: {
        title: 'Štatistiky použitia vstupeniek',
        zone: 'Zóna',
        today: 'Dnes',
        total: 'Spolu',
        refresh: 'Obnoviť dáta'
    },
    verify: {
        title: 'Overenie vstupenky',
        enterCode: 'Zadajte kód vstupenky',
        verify: 'Overiť',
        scanHint: 'Naskenujte kód alebo zadajte ručne',
        notFound: 'Vstupenka nenájdená',
        found: 'Vstupenka nájdená',
        email: 'E-mail',
        entries: 'Vstupov',
        people: 'Osôb',
        entryPause: 'Odstup vstupu (min)',
        purchased: 'Zakúpená',
        validUntil: 'Platná do',
        event: 'Udalosť',
        ticketset: 'Sada vstupeniek',
        price: 'Cenová hladina',
        zones: 'Zóny',
        noZones: 'Vstupenka nie je priradená k žiadnej zóne.',
        slots: 'Sloty',
        noSlots: 'Vstupenka nie je priradená k žiadnemu slotu.',
        usageForZone: 'Využitie v zóne',
        remains: 'Zostáva',
        usageLogs: 'Záznam použitia vstupeniek',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Nové overenie'
    }
} as const
